/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { getModelOutput } from "../../funcs/getModelOutput.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetModelOutputRequest$inboundSchema,
};

export const tool$getModelOutput: ToolDefinition<typeof args> = {
  name: "get-model-output",
  description: `Get the output of a model for a given symbol

Returns all output from a requested model over a given time span. The model`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await getModelOutput(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
